import identifyDiv from './identifyDiv.vue';
export default identifyDiv;
